// extracted by mini-css-extract-plugin
export default {"section":"Home_section__45cYO","section__title":"Home_section__title__vAK1-"};